var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('canvas',{attrs:{"id":_vm.chartId,"data":_vm.data}})])
}
var staticRenderFns = []

export { render, staticRenderFns }